var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Svg, { Path } from 'react-native-svg';
import { checkIsPlatform } from '../../utils';
var SvgSubtractIcon = props => {
  var accessibilityLabelKey = checkIsPlatform('web') ? 'aria-label' : 'accessibilityLabel';
  var _props = props,
    _props$fontSize = _props.fontSize,
    fontSize = _props$fontSize === void 0 ? 24 : _props$fontSize,
    _props$color = _props.color,
    color = _props$color === void 0 ? '#292C31' : _props$color,
    testID = _props.testID,
    accessibilityLabel = _props.accessibilityLabel,
    restProps = __rest(props, ["fontSize", "color", "testID", "accessibilityLabel"]);
  props = Object.assign(Object.assign({
    fontSize,
    color,
    id: testID
  }, restProps), accessibilityLabel && {
    [accessibilityLabelKey]: accessibilityLabel
  });
  return _jsx(Svg, Object.assign({
    width: fontSize,
    height: fontSize,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: _jsx(Path, {
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M6 12h12"
    })
  }));
};
export default SvgSubtractIcon;